// components/LinkNext.tsx
"use client";

import Link, { LinkProps } from "next/link";
import { useSearchParams } from "next/navigation";
import { ReactNode } from "react";

interface LinkNextProps extends LinkProps {
  children: ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export default function LinkNext({
  href,
  children,
  className,
  style,
  ...props
}: LinkNextProps) {
  const searchParams = useSearchParams();
  const next = searchParams.get("next");

  let newHref: string;

  if (typeof href === "string") {
    // href est une string
    newHref = href;
    if (next) {
      const url = new URL(href, window.location.origin);
      url.searchParams.set("next", next);
      newHref = url.pathname + url.search;
    }
  } else {
    // href est un objet { pathname, query }
    const pathname = href.pathname ?? "/";
    const url = new URL(pathname, window.location.origin);

    if (href.query) {
      Object.entries(href.query).forEach(([k, v]) => {
        if (typeof v === "string") url.searchParams.set(k, v);
        else if (Array.isArray(v))
          v.forEach((val) => url.searchParams.append(k, val));
      });
    }

    if (next) url.searchParams.set("next", next);

    newHref = url.pathname + url.search;
  }

  return (
    <Link href={newHref} {...props} className={className} style={style}>
      {children}
    </Link>
  );
}
